import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import CommonService from 'services/CommonService';
import { IColumnModel } from 'models/IColumnModel';
import CustomDataTable from 'components/shared/CustomDataTable';
import { ISearchModel } from 'models/ISearch.Model';
import BecomeAPartnerPopUp from './BecomeAPartnerPopUp';
import { IGetBecomeAPartner } from 'models/IGetBecomeAPartner';
import { useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import { HelperConstant } from '../../helpers/HelperConstant';
import StatusStatsFilters from 'components/filter/StatusStatsFilters';
import { downloadCSV, downloadMobileInvoice } from '../../helpers/Helper';
import { Capacitor } from '@capacitor/core';
import UseDebounce from 'components/shared/UseDebounce';
import PartnerService from 'services/Partner.Service';
import CustomLoader from 'components/Common/CustomLoader';

function BecomeAPartner() {
    const [editModal, setEditModal] = useState(0);
    const [searchText, setSearchText] = useState<any>();
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [search, setSearch] = useState("");
    const [becomeapartnerData, setbecomeapartnerData] = useState<Array<any>>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [statusList, setStatusList] = useState<Array<any>>([]);
    const [isStatusId, setIsStatusId] = useState("");
    const debouncedSearch = UseDebounce(searchText, 1000);
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);
    const [isload, setIsLoad] = useState(false);
    const statusName = isStatusId ? statusList.filter(x => x.Id == isStatusId)[0]?.Name : HelperConstant.Became_a_Partner_StatusEnums.Open;
    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);

    const columns: IColumnModel[] = useMemo(() => [
        // {
        //     Header: 'Id',
        //     accessor: 'Id',
        //     width: "0%",
        //     displayInList: true,
        //     Filter: false,
        //     sortable: true,
        // },
        {
            Header: 'Created On',
            accessor: 'Created',
            width: "10%",
            displayInList: true,
            Filter: true,
            datatype: "date"
        },
        {
            Header: 'Code',
            accessor: 'PartnerCode',
            displayInList: true,
            width: "20%",
            Filter: true,
            isSortable: true,
            isSorted: true,
            datatype: "linkbtn"
        },
        {
            Header: 'Company Name',
            accessor: 'CompanyName',
            width: "30%",
            displayInList: true,
            Filter: true,
            isSortable: false,
            isSorted: false
        },
        {
            Header: 'Contact Person Name',
            accessor: 'ContactPersonName',
            width: "30%",
            displayInList: true,
            Filter: false,
            isSortable: false,
            isSorted: false

        }, {
            Header: 'Email',
            accessor: 'EmailId',
            displayInList: true,
            width: "30%",
            Filter: false,
            isSorted: false,
            isSortable: false,
        },
        {
            Header: 'Mobile Phone',
            accessor: 'MobilePhone',
            displayInList: true,
            width: "30%",
            Filter: false,
            isSortable: false,
            isSorted: false
        },
        {
            Header: 'State',
            accessor: 'State',
            displayInList: true,
            width: "20%",
            Filter: false,
            isSortable: false,
            isSorted: false
        },
        {
            Header: 'District',
            accessor: 'District',
            displayInList: true,
            width: "20%",
            Filter: false,
            isSortable: false,
            isSorted: false
        },
        {
            Header: 'Status',
            accessor: 'StatusName',
            displayInList: true,
            width: "10%",
            Filter: false,
            isSortable: false,
            isSorted: false

        },
    ], []);



    const searchByText = (pageNumber: any, searchText: any, statusId: any, sortcolumn?: any, sortorder?: any) => {
        setIsLoad(true);
        getStatus();
        let searchModel: ISearchModel = {
            offsetStart: offsetStart,
            rowsPerPage: rowsPerPage,
            sortOrder: sortorder ? sortorder : "desc",
            sortOrderColumn: sortcolumn ? "PartnerCode" : "modified",
            searchText: searchText,
            StatusId: statusId ? parseInt(statusId) : HelperConstant.BecameAPartnerStatusId.Open,
            FromDate: fromDate,
            ToDate: toDate
        }
        CommonService.post('Partner', 'GetPartnerList', searchModel).then(res => {
            if (res.status == 200) {
                let data: Array<IGetBecomeAPartner> = res.data
                setbecomeapartnerData(data);
                setTotalRecords(data.length);
                setIsLoad(false);
            }
        });
    }

    const editHandler = (val) => {
        setEditModal(val.Id);
    }

    const searchHandler = (searchKeyword: any) => {
        setSearchText(searchKeyword);
        searchByText(0, searchKeyword, isStatusId);
    }

    const onColumnSortChange = (columnName, sortorder) => {
        if (columnName == "PartnerCode") {
            setSelectedColumn(columnName);
            setSortOrder(sortorder);
            searchByText(0, search, isStatusId, columnName, sortorder);
        }
    };

    const pagination = (pageNumber: any) => {
        searchByText(pageNumber, search, selectedColumn, sortOrder);
    }

    const selectedPartner = becomeapartnerData.find(partner => partner.Id === editModal);

    const getStatus = () => {
        PartnerService.GetBecameaPartnerStats(HelperConstant.EntityTypeId.BECOME_A_PARTNER).then(res => {
            if (res.status === 200) {
                setStatusList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const getBecameaPartnerExport = () => {
        setIsLoad(true);
        const fileName = `DOFY_BecameaPartnerList_${statusName}`;

        PartnerService.GetBecameaPartnerExport({
            SortOrder: "desc",
            SortOrderColumn: "modified",
            statusId: isStatusId ? parseInt(isStatusId) : HelperConstant.BecameAPartnerStatusId.Open,
            searchText: debouncedSearch,
            FromDate: fromDate,
            ToDate: toDate,
            offsetStart: null,
            rowsPerPage: null

        }).then(res => {
            if (res.status === 200) {
                if (Capacitor.isNativePlatform()) {
                    let concatedBase64 = "data:application/octet-stream;base64, " + res.data;
                    downloadMobileInvoice(concatedBase64, fileName + ".xls");
                } else {
                    downloadCSV(res.data, fileName);
                }
                setIsLoad(false);
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    useEffect(() => {
        searchByText(0, debouncedSearch, isStatusId);
    }, [offsetStart, rowsPerPage, isStatusId, fromDate, toDate]);


    return (
        <div className="page-content">
            <CustomLoader isOpen={isload} />
            <Container fluid className="p-0">
                <div className="d-flex justify-content-between">
                    <h5 className="fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>BECOME A PARTNER</h5>
                    {/* <StatusFilters statusList={statusList} onClick={(id: any) => { setIsStatusId(id) }} statusName={isStatusId ? statusList.filter(x => x.Id == isStatusId)[0]?.Name : HelperConstant.Request_For_Pickup_StatusEnums.Open} /> */}
                </div>
                <StatusStatsFilters statusList={statusList} onClick={(id: any) => { setIsStatusId(id) }} statusName={statusName} onExport={getBecameaPartnerExport} onFromDateChange={(value: any) => setFromDate(value)} onToDateChange={(value: any) => setToDate(value)} CreatedFromDateLabel="Created From Date" CreatedToDateLabel="Created To Date" />

                <Row>
                    <Col xl={12}>
                        <CustomDataTable
                            isPagination={becomeapartnerData[0]?.TotalRowsCount > 50 ? true : true}
                            customPageSize={50}
                            isActionEdit={false}
                            isActionDelete={false}
                            editHandler={undefined}
                            linkBtnhandler={editHandler}
                            isGlobalFilter={true}
                            searchHandler={searchHandler}
                            onColumnSortChange={onColumnSortChange}
                            canShowButton1={false}
                            selectedPage={pagination}
                            canShowButton2={false}
                            deleteHandler={undefined}
                            createHandler={undefined}
                            path={''}
                            firstBtnName={''}
                            specialGrid={false}
                            recordsCount={becomeapartnerData[0]?.TotalRowsCount}
                            pageSize={rowsPerPage}
                            columns={columns}
                            data={becomeapartnerData}
                            rowsPerPage={rowsPerPage}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            offsetStart={offsetStart}
                            setOffsetStart={setOffsetStart} />
                    </Col>
                </Row>
                <Modal size='lg' isOpen={editModal > 0} centered>
                    <ModalHeader toggle={() => { setEditModal(0); searchByText(0, searchText, isStatusId) }}>
                        <i className='fas fa-user-edit text-dofy me-2 font-size-15'></i>
                        <span className='font-size-16 fw-semibold text-dofy'>Become A Partner Edit</span>
                        {selectedPartner?.LocationCode && (
                            <span className={`badge rounded-pill badge-soft-info font-size-8 fw-bolder px-2 pt-2`} style={{ marginLeft: '20px' }}>
                                <p style={{ color: "#1e4495", fontWeight: 'bold', fontSize: '15px', marginBottom: '8px' }}>Code: {selectedPartner.LocationCode}</p>
                            </span>
                        )}
                    </ModalHeader>
                    <ModalBody className='py-2 '>
                        <div className='d-flex justify-content-between'>
                            {selectedPartner?.PartnerCode && (
                                <Badge className='bg-info fs-6 mx-2'>
                                    {selectedPartner?.PartnerCode}
                                </Badge>
                            )}
                            {selectedPartner?.StatusId && (
                                <Badge className={`${selectedPartner.StatusId == HelperConstant.BecameAPartnerStatusId.Approved ? "bg-success" : selectedPartner.StatusId == HelperConstant.BecameAPartnerStatusId.Rejected ? "bg-danger" : "bg-light"} fs-6 mx-2`}>
                                    {selectedPartner?.StatusName}
                                </Badge>
                            )}
                        </div>
                        <BecomeAPartnerPopUp Id={editModal} setEditModel={setEditModal} requestData={searchByText} statusId={isStatusId} statusList={statusList} />
                    </ModalBody>
                </Modal>
            </Container >
        </div >
    )
}

export default BecomeAPartner